module.exports = __webpack_public_path__ + "static/media/user_is_free_warn.926af7c9.png";